






























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import BaseDataTable from '@/components/BaseDataTable.vue';
import moment from 'moment';
import Auth from '@/connector/Auth.vue';
import BaseDateRangeSearch from '@/components/BaseDateRangeSearch.vue';
import TransactionService from '@/services/TransactionService';

const transactionService = new TransactionService();

@Component({
  components: {
    BaseDataTable,
    Auth,
    BaseDateRangeSearch,
  },
  filters: {
    twoPointDecimal: (value: any) => Number(value).toFixed(2),
  },
})
export default class PlayerRefundList extends Vue {
  public textSearch: string = '';

  public loading: boolean = false;

  public amount: number = 0;

  public range: string = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')].toString();

  public summary: number = 0;

  // eslint-disable-next-line class-methods-use-this
  get refundUrl() {
    return `${process.env.VUE_APP_API_ENDPOINT}/transactions/refund`;
  }

  // eslint-disable-next-line class-methods-use-this
  public formatDate(time: number) {
    return moment(time).format('YYYY-MM-DD HH:mm:ss');
  }

  public setSearchText(value: string) {
    this.textSearch = value;
  }

  async search(data: any) {
    this.range = data;
  }

  @Watch('range', { immediate: true })
  // eslint-disable-next-line class-methods-use-this
  async onRangeChange(value: string) {
    const { data } = await transactionService.getRefundSummary(value);
    if (data.refundSummary) {
      this.summary = data.refundSummary;
    }
  }

  // async updatePassword() {
  //   try {
  //     this.loading = true;
  //     await playerService.updatePlayer(
  //       this.selectedPasswordChangePlayerId,
  //       { password: this.password },
  //     );
  //     this.loading = false;
  // eslint-disable-next-line max-len
  //     this.$store.commit('Snackbar/showNotification', { message: 'เปลี่ยนรหัสผ่านเรียบร้อยแล้ว', error: false });
  //     this.passwordChangeDialog = false;
  //   } catch (e) {
  //     this.loading = false;
  //     this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
  //   }
  // }
}
